/**
 * Mirrors backend `hash_password` in `backend/src/utilities/permissions.py`.
 */

export type PasswordPolicyRule = {
  id: string;
  /** Short label for UI checklists */
  label: string;
  /** Exact API / server error text for consistency */
  detail: string;
  test: (password: string) => boolean;
};

export const PASSWORD_POLICY_RULES: readonly PasswordPolicyRule[] = [
  {
    id: 'length',
    label: 'At least 8 characters long',
    detail: 'Password must be at least 8 characters long',
    test: p => p.length >= 8,
  },
  {
    id: 'uppercase',
    label: 'At least one uppercase letter',
    detail: 'Password must contain at least one uppercase letter',
    test: p => /[A-Z]/.test(p),
  },
  {
    id: 'lowercase',
    label: 'At least one lowercase letter',
    detail: 'Password must contain at least one lowercase letter',
    test: p => /[a-z]/.test(p),
  },
  {
    id: 'digit',
    label: 'At least one number',
    detail: 'Password must contain at least one number',
    test: p => /[0-9]/.test(p),
  },
] as const;

/** First failing rule detail (same strings the API returns), or null if all pass. */
export function getPasswordPolicyViolationDetail(password: string): string | null {
  for (const rule of PASSWORD_POLICY_RULES) {
    if (!rule.test(password)) {
      return rule.detail;
    }
  }
  return null;
}
